<!--
 * @Author: wsx
 * @Date: 2022-01-13 11:02:09
 * @LastEditTime: 2022-02-14 11:53:53
 * @LastEditors: Please set LastEditors
 * @Description: 角色管理
-->
<template>
  <el-container class="RoleManage">
    <el-card class="role-card" :body-style="treeCard">
      <div class="role-btn">
        <h-button type="primary" @click="addOrgan">添加</h-button>
        <h-button type="success" @click="editOrgan">编辑</h-button>
        <h-button type="danger" @click="delOrgan">删除</h-button>
      </div>
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="role-box">
        <div class="role-tr role-header">
          <span class="role-name">名称</span>
          <span class="role-status">状态</span>
          <span class="role-number">成员数量</span>
        </div>
        <ul>
          <li
            class="role-tr role-item"
            :class="{ current: currentRole.roleId === item.roleId }"
            v-for="item in roleList"
            :key="item.roleId"
            @click="currentChange(item)"
          >
            <span class="role-tb role-name">{{ item.roleName }}</span>
            <span class="role-tb role-status">
              <el-switch
                v-model="item.status"
                active-value="1"
                inactive-value="2"
              />
            </span>
            <span class="role-tb role-number">{{ item.userNum }}</span>
          </li>
        </ul>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-tabs class="tabs-box" v-model="tabsVal">
        <el-tab-pane name="1" label="功能权限" class="tabs-box">
          <tabs-menu :role="currentRole"></tabs-menu>
        </el-tab-pane>
        <el-tab-pane
          name="2"
          label="数据权限"
          class="tabs-box"
          @change="queryRoleAsync"
        >
          <tabs-data :role="currentRole"></tabs-data>
        </el-tab-pane>
        <!-- <el-tab-pane name='3' label="字段权限" class="tabs-box">
          <tabs-field :role="currentRole"></tabs-field>
        </el-tab-pane> -->
        <el-tab-pane name="4" label="成员列表" class="tabs-box">
          <tabs-table :role="currentRole" v-if="tabsVal === '4'"></tabs-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog
      v-model="dialogVisible"
      title="添加/编辑部门"
      width="30%"
      @close="close"
    >
      <el-form
        ref="formRef"
        :model="formInline"
        label-width="100px"
        :rules="rules"
        class="demo-dynamic"
      >
        <el-form-item prop="roleName" label="角色名称">
          <el-input v-model="formInline.roleName"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formInline.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <h-button type="primary" @click="submitForm(formRef)">提交</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>

          <h-button @click="dialogVisible = false">取消</h-button>
        </span>
      </template>
    </el-dialog>
  </el-container>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watch,
  ref,
  h,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import TabsMenu from "./components/TabsMenu.vue";
import TabsData from "./components/TabsData.vue";
import TabsField from "./components/TabsField.vue";
import TabsTable from "./components/TabsTable.vue";
import util from "@util/js";
import {
  getRoleList,
  roleSave,
  roleUpdate,
  roleDelete,
} from "@/api/system/role.js";
import _ from "lodash";
export default defineComponent({
  name: "RoleManage",
  components: { TabsMenu, TabsData, TabsField, TabsTable },
  props: {},
  setup(props) {
    const state = reactive({
      isInit: false,
      isAdd: true,
      formInline: {
        roleName: "",
        remark: "",
        menuIdList: [],
        type: 1,
      },
      formInlineBack: {},
      value1: "",
      rules: {
        roleName: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur",
          },
        ],
      },
      currentRole: {},
      dialogVisible: false,
      activeName: "tabel",
      tabsVal: "1",
      filterText: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      roleList: [],
      roleListSource: [],
    });
    state.formInlineBack = _.cloneDeep(state.formInline);
    const formRef = ref();
    const treeRef = ref(null);
    const tableRef = ref(null);
    const refData = toRefs(state);
    const onSubmit = () => {
      console.log("submit!");
    };
    // 删除角色
    const delOrgan = () => {
      const treedata = state.currentRole;
      if (!treedata.roleId) {
        ElMessage({
          type: "waring",
          message: "请选择要删除的角色",
        });
      } else {
        ElMessageBox({
          title: "删除",
          message: h("div", { style: "text-align: center;font-size:16px;" }, [
            h("p", null, "您确认要删除该角色吗？"),
            h("p", null, "删除前请确认角色不存在成员（成员数量为0）"),
          ]),
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }).then(async () => {
          const res = await roleDelete([treedata.roleId]);
          if (res.code === 0) {
            queryRoleAsync();
            ElMessage({
              type: "success",
              message: "删除成功",
            });
          }
        });
      }
    };

    // 获取角色列表
    const queryRoleAsync = async () => {
      const res = await getRoleList();
      state.roleList = state.roleListSource = res.roleList;
      state.roleListSource = res.roleList;
      let role;
      if (state.isInit) {
        role = state.currentRole;
      } else {
        state.isInit = true;
        if (state.roleList[0]) {
          role = state.roleList[0];
        }
      }
      currentChange(role);
    };
    queryRoleAsync();
    // 添加按钮
    const addOrgan = () => {
      resetForm(formRef.value);
      state.isAdd = true;
      state.dialogVisible = true;
    };
    // 编辑
    const editOrgan = () => {
      resetForm(formRef.value);
      state.isAdd = false;
      state.dialogVisible = true;
      state.formInline = _.cloneDeep(state.currentRole);
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 提交数据
    const submitForm = (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          let res;
          const form = _.cloneDeep(state.formInline);
          if (!form.menuIdList) {
            form.menuIdList = [];
          }
          util.formatForm(form);
          if (state.isAdd) {
            res = await roleSave(form);
          } else {
            res = await roleUpdate(form);
          }
          if (res.code === 0) {
            ElMessage({
              type: "success",
              message: state.isAdd ? "添加成功" : "修改成功",
            });
            state.dialogVisible = false;
            queryRoleAsync();
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item) => {
      state.currentRole = item;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };

    // 组织树的筛选
    watch(
      () => state.filterText,
      (v) => {
        state.roleList = state.roleListSource.filter((item) => {
          return item.roleName.includes(v);
        });
      }
    );
    const close = () => {
      state.formInline = _.cloneDeep(state.formInlineBack);
    };
    return {
      ...refData,
      treeRef,
      tableRef,
      formRef,
      onSubmit,
      delOrgan,
      addOrgan,
      resetForm,
      submitForm,
      editOrgan,
      currentChange,
      queryRoleAsync,
      close,
    };
  },
});
</script>
<style lang="scss" scoped>
.RoleManage {
  .role-card {
    height: 100%;
    width: 400px;
    .role-btn {
      margin-bottom: 10px;
    }
    .role-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .role-tr {
        line-height: 35px;
        padding: 0 5px;
        box-sizing: border-box;
        @include flex-row-sb-c;
        &.role-item {
          border: 1px solid var(--el-border-color-base);
          margin: 2px 0;
          border-radius: 5px;
          cursor: pointer;
          &:hover,
          &.current {
            background-color: var(--el-color-primary-light-8);
          }
        }
        .role-name {
          width: 50%;
        }
        .role-status {
          width: 20%;
        }
        .role-number {
          width: 30%;
          text-align: center;
        }
      }
      .role-header {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
  }
  .customStyle {
    .name {
      line-height: 26px;
    }
    .text {
      text-align: left;
      font-size: 14px;
    }
  }
}
</style>
